export const MonthYearData = [
    { value: "Janurary 2021", option: "Janurary 2021" },
    { value: "February 2021", option: "February 2021" },
    { value: "March 2021", option: "March 2021" },
    { value: "April 2021", option: "April 2021" },
    { value: "May 2021", option: "May 2021" },
    { value: "June 2021", option: "June 2021" },
    { value: "July 2021", option: "July 2021" },
    { value: "August 2021", option: "August 2021" },
    { value: "September 2021", option: "September 2021" },
    { value: "October 2021", option: "October 2021" },
    { value: "November 2021", option: "November 2021" },
    { value: "December 2021", option: "December 2021" },
    { value: "Janurary 2022", option: "Janurary 2022" },
    { value: "February 2022", option: "February 2022" },
    { value: "March 2022", option: "March 2022" },
    { value: "April 2022", option: "April 2022" },
    { value: "May 2022", option: "May 2022" },
    { value: "June 2022", option: "June 2022" },
    { value: "July 2022", option: "July 2022" },
    { value: "August 2022", option: "August 2022" },
    { value: "September 2022", option: "September 2022" },
    { value: "October 2022", option: "October 2022" },
    { value: "November 2022", option: "November 2022" },
    { value: "December 2022", option: "December 2022" },
    { value: "Janurary 2023", option: "Janurary 2023" },
    { value: "February 2023", option: "February 2023" },
    { value: "March 2023", option: "March 2023" },
    { value: "April 2023", option: "April 2023" },
    { value: "May 2023", option: "May 2023" },
    { value: "June 2023", option: "June 2023" },
    { value: "July 2023", option: "July 2023" },
    { value: "August 2023", option: "August 2023" },
    { value: "September 2023", option: "September 2023" },
    { value: "October 2023", option: "October 2023" },
    { value: "November 2023", option: "November 2023" },
    { value: "December 2023", option: "December 2023" },
    { value: "Janurary 2024", option: "Janurary 2024" },
    { value: "February 2024", option: "February 2024" },
    { value: "March 2024", option: "March 2024" },
    { value: "April 2024", option: "April 2024" },
    { value: "May 2024", option: "May 2024" },
    { value: "June 2024", option: "June 2024" },
    { value: "July 2024", option: "July 2024" },
    { value: "August 2024", option: "August 2024" },
    { value: "September 2024", option: "September 2024" },
    { value: "October 2024", option: "October 2024" },
    { value: "November 2024", option: "November 2024" },
    { value: "December 2024", option: "December 2024" },
    { value: "Janurary 2025", option: "Janurary 2025" },
    { value: "February 2025", option: "February 2025" },
    { value: "March 2025", option: "March 2025" },
    { value: "April 2025", option: "April 2025" },
    { value: "May 2025", option: "May 2025" },
    { value: "June 2025", option: "June 2025" },
    { value: "July 2025", option: "July 2025" },
    { value: "August 2025", option: "August 2025" },
    { value: "September 2025", option: "September 2025" },
    { value: "October 2025", option: "October 2025" },
    { value: "November 2025", option: "November 2025" },
    { value: "December 2025", option: "December 2025" },
    { value: "Janurary 2026", option: "Janurary 2026" },
    { value: "February 2026", option: "February 2026" },
    { value: "March 2026", option: "March 2026" },
    { value: "April 2026", option: "April 2026" },
    { value: "May 2026", option: "May 2026" },
    { value: "June 2026", option: "June 2026" },
    { value: "July 2026", option: "July 2026" },
    { value: "August 2026", option: "August 2026" },
    { value: "September 2026", option: "September 2026" },
    { value: "October 2026", option: "October 2026" },
    { value: "November 2026", option: "November 2026" },
    { value: "December 2026", option: "December 2026" },
];